import React from "react";
import { GetStarted, HomeHero } from "../components/home";
import { PrimaryLayout } from "../shared/layouts";
import "./index.css";

const IndexPage = () => (
    <PrimaryLayout slantedFooter>
        <HomeHero />
        <GetStarted />
    </PrimaryLayout>
);

export default IndexPage;
